import { RmOccupancyEnum } from "@gtpl/shared-models/masters"
import { ApiProperty } from "@nestjs/swagger"

export class RackStatusRequestDto {
    @ApiProperty()
    rmRackPositionId:number
    @ApiProperty()
    status:RmOccupancyEnum
    @ApiProperty()
    plantId:number
    @ApiProperty()
    itemSubCategoryId:number
    @ApiProperty()
    brandId:number
}